import React, { useState, useEffect, useMemo } from 'react';
import NackleMenu from '@nackle/menu';
import { setLanguageBundle } from '@nackle/intl-tools';
import auth from '../../../auth/auth'; 
import { CMX_SERVICE_URI } from '../../../const/uri';
import { authService } from '../../../auth/authService';
import './styles.less';

const AppSidebar = () => {
    const [ translationsLoaded, setTranslationsLoaded ] = useState( false );
    
    const showSidebar = useMemo( () =>
        !window.location.hostname.toLowerCase().includes( 'localhost' ), [] ); 

    useEffect( () => { 
        if ( !showSidebar ) { 
            return;
        }

        const getNavigationBundle = async () => {
            try {
                const response = await fetch( 
                    `${ CMX_SERVICE_URI }/bundle/navigation`, 
                    {   
                        method: 'POST',
                        body: JSON.stringify( { locales: [ 'en-US' ] } ),
                        headers: {
                            'Authorization': `Bearer ${ authService.getAccessToken() }`,
                            'content-type': 'application/json',
                            'Accept': 'application/json'
                        } 
                    }
                );
    
                return response?.ok ? await response.json() : undefined;
        
            } catch ( error ) {
                console.error( error );
            }
        };

        getNavigationBundle().then( ( bundle ) => {
            if ( bundle?.bundles ) {
                setLanguageBundle( 'en-US', bundle.bundles[ 'en-US' ] );
                setTranslationsLoaded( true );
            }
        } );
    }, [ setTranslationsLoaded, showSidebar ] );

    return (
        <>
            { translationsLoaded && 
                <NackleMenu
                    auth={ auth }
                    cmxBundleLoaded={ translationsLoaded }
                    collapsible
                />
            }
        </>
    );
};

export default AppSidebar; 
